import getStore from "../store/store";
import { getAccountKeyForMailboxInfo } from "owa-client-types";
import { logPrioritizeTelemetryEvent } from "owa-copilot-telemetry/lib/prioritizeTelemetryLogger";
import type { MailboxInfo } from "owa-client-types";
import type CopilotPrioritizeSettings from "../types/CopilotPrioritizeSettings";

let hasLogged = false;
function logUsageOncePerSession(mailboxInfo: MailboxInfo, data: Record<string, any>): void {
    if (!hasLogged) {
        logPrioritizeTelemetryEvent("OpenInbox", mailboxInfo, data);
        hasLogged = true;
    }
}

export default function savePrioritizeSettings(mailboxInfo: MailboxInfo, inboxResponse: CopilotPrioritizeSettings): void {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    
    const prioritizeStoreMap = getStore().copilotPrioritizeSettingsStoreMap;
    const prioritizeStore = prioritizeStoreMap.get(accountKey);
    
    if (inboxResponse.version === 1) {
        inboxResponse.replacePreviewWithMicroSummary = true;
    }
    
    if (inboxResponse.prioritizationEnabled &&
        ((inboxResponse.moreImportantRules?.length ?? 0) > 0 ||
            (inboxResponse.lessImportantRules?.length ?? 0) > 0 ||
            (inboxResponse.miscellaneousRules?.length ?? 0) > 0)) {
        logUsageOncePerSession(mailboxInfo, {
            PrioritizationEnabled: inboxResponse.prioritizationEnabled,
            ApplyLowPriorityLabel: inboxResponse.applyLowPriorityLabel,
            MoreImportantRulesCount: inboxResponse.moreImportantRules?.length ?? 0,
            LessImportantRulesCount: inboxResponse.lessImportantRules?.length ?? 0,
            MiscellaneousRulesCount: inboxResponse.miscellaneousRules?.length ?? 0,
        });
    }
    
    if (prioritizeStore) {
        prioritizeStore.settings = inboxResponse;
        prioritizeStore.isInitialized = true;
        prioritizeStore.version = prioritizeStore.version + 1;
    }
    else {
        prioritizeStoreMap.set(getAccountKeyForMailboxInfo(mailboxInfo), {
            settings: inboxResponse,
            isInitialized: true,
            version: 1,
        });
    }
}
